import { css, SerializedStyles } from '@emotion/react';
import { useTheme } from '@mui/material';

export const useDateFiltersStyles = (): SerializedStyles => {
  const theme = useTheme();

  return css`
    padding: ${theme.spacing(3)};

    .align-right {
      text-align: right;
    }

    .range-grid-block {
      ${theme.breakpoints.down('sm')} {
        padding: ${theme.spacing(2)} ${theme.spacing(1)};
      }
    }

    .date-field {
      width: 100%;

      ${theme.breakpoints.down('sm')} {
        &:not(:last-of-type) {
          margin-bottom: ${theme.spacing(2)};
        }
      }
    }
  `;
};
